import assetPath from '/app/xinglets/startpage-logged-out/entry/src/companies-section/assets/siemens-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')